import { render, staticRenderFns } from "./duiWaiTouZi.vue?vue&type=template&id=3bb1f1d2&"
import script from "./duiWaiTouZi.vue?vue&type=script&lang=js&"
export * from "./duiWaiTouZi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports